import { useIntl } from 'react-intl';
import { cn } from 'utils/classNamesTailwind';
import { ProfitabilityStatus } from 'components/profitability/types';
import { statusColorClass, statusLabelId } from 'components/profitability/profitabilityStatus';

export function StatusCell({ status }: { status: ProfitabilityStatus }) {
  const intl = useIntl();
  const { dot } = statusColorClass(status);
  return (
    <div className="flex items-center gap-1.5">
      <span className={cn('inline-block w-3 h-3 rounded-full flex-shrink-0', dot)} />
      <span>{intl.formatMessage({ id: statusLabelId(status) })}</span>
    </div>
  );
}
